import "client-only";
import { fetcher } from "src/utils/fetcher";
import useSWR from "swr";
function useSettingBatchCode() {
  return useSWR(
    {
      path: `/api/v1/settings`,
      method: "GET",
    },
    fetcher,
    {
      revalidateOnFocus: true,
      revalidateOnMount: true,
    },
  );
}

export default useSettingBatchCode;
